import { OrganizationExperienceDetail } from '../organization/OrganizationExperienceDetail';
import { useAuthContext } from '../../contexts/AuthContext';
import { useParams } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';

function OrganizationExperienceDetailWrapper() {
    const { guid } = useParams();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    return (
        <OrganizationExperienceDetail
            portfolioGuid={guid || ''}
            user={user}
            zoneContext={zoneContext}
        />
    );
}

export default OrganizationExperienceDetailWrapper;
